module.exports = __webpack_public_path__ + "img/ilham-aliyev.2d41bec3.jpg";